import * as React from 'react'
import { Text } from 'react-native'
import { Fonts } from '@themes/Fonts'
import styles from './styles'
import type { Goal } from '../helpers'

export function ProgressMessage({
  period,
  currentValue,
  targetValue,
}: {
  period: Goal['period']
  currentValue: Goal['currentValue']
  targetValue: Goal['targetValue']
}) {
  const valueRemaining = targetValue - currentValue

  return (
    <>
      {valueRemaining <= 0 ? (
        <Text style={styles.goalProgressMessage}>You’ve met your goal!</Text>
      ) : (
        <Text style={styles.goalProgressMessage}>
          <Text style={styles.goalProgressMessage}>You have</Text>
          <Text
            style={[
              styles.goalProgressMessage,
              Fonts.typeWithWeight.sourceBold,
            ]}
          >{` ${valueRemaining} more need${
            valueRemaining !== 1 && 's'
          } `}</Text>
          <Text style={styles.goalProgressMessage}>
            {`to meet this ${period.noun}.`}
          </Text>
        </Text>
      )}
    </>
  )
}
